import { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';

function usePreviousPath() {
  const location = useLocation();
  const historyRef = useRef(JSON.parse(localStorage.getItem('navigationHistory') || '["/"]'));

  useEffect(() => {
    if (!Array.isArray(historyRef.current) || historyRef.current.length === 0) {
      historyRef.current = [location.pathname];
      localStorage.setItem('navigationHistory', JSON.stringify(historyRef.current));
    } else if (historyRef.current[historyRef.current.length - 1] !== location.pathname) {
      historyRef.current.push(location.pathname);
      if (historyRef.current.length > 2) {
        historyRef.current.shift();
      }
      localStorage.setItem('navigationHistory', JSON.stringify(historyRef.current));
    }
  }, [location.pathname]);

  return historyRef.current[historyRef.current.length - 2] || '/';
}

export function HistoryTracker() {
  usePreviousPath();
  return null;
}

export function PreviousPathLink() {
  const previousPath = usePreviousPath();

  return (
    <Link to={previousPath} aria-label="Go back to previous page">
      <ArrowLeftIcon className="w-4 h-4 hover:scale-125 transition-transform duration-200" />
    </Link>
  );
}
